import { Suspense, lazy } from 'react'
import { WorkOsWidgets } from '@workos-inc/widgets'
import { ThemeProvider, useTheme } from '@/contexts/theme.context'

const AppAuthProvider = lazy(() =>
  import('@/contexts/app-auth.context').then(mod => ({
    default: mod.AppAuthProvider,
  })),
)

function WorkOsWidgetsWithAppTheme({
  children,
}: {
  children: React.ReactNode
}) {
  const { resolvedTheme } = useTheme()
  return (
    <WorkOsWidgets
      theme={{
        appearance: resolvedTheme,
        accentColor: 'blue',
        grayColor: 'gray',
        radius: 'medium',
        scaling: '100%',
      }}
    >
      {children}
    </WorkOsWidgets>
  )
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <WorkOsWidgetsWithAppTheme>
        <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
          <AppAuthProvider>{children}</AppAuthProvider>
        </Suspense>
      </WorkOsWidgetsWithAppTheme>
    </ThemeProvider>
  )
}
